var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-col",
    { staticClass: "mt-3", attrs: { id: "timeline-container", cols: "12" } },
    [
      _c(
        "div",
        { staticClass: "nav-tabs-wrapper bb-0" },
        [
          _c("navbar", {
            attrs: {
              tabs: _vm.tabs,
              "current-tab": _vm.currentTab,
              "container-class": "scroll-container",
            },
            on: { "tab-change": _vm.setCurrentTab },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { id: "timeline-tabs-container" } },
        [
          !_vm.isChangelog
            ? _c("referrer-timeline-list", {
                attrs: {
                  "timeline-list": _vm.timelineList,
                  "is-empty-timeline": _vm.isEmptyTimeline,
                  "referrer-id": _vm.referrerId,
                },
                on: {
                  filter: _vm.setCurrentTab,
                  "load-time-line": _vm.loadTimeLine,
                },
              })
            : _c("referrer-timeline-changelog", {
                attrs: { "referrer-id": _vm.referrerId },
              }),
          _vm._v(" "),
          _c("referrer-activity-convert-modal", {
            attrs: {
              "modal-id": "referrer-activity-convert-modal",
              "referrer-id": _vm.referrerId,
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }